import { getGFT, postGFT } from '@/common/utils/ajax'

const getQuestions = (entrance) => getGFT('v1/aqr/questions', { entrance })

const selectQuestion = (question_id, params = {}) => postGFT('v1/aqr/recommendations', { question_id, ...params })

const getRecommendBuilding = (id) => getGFT(`v1/aqr/recommendations/${id}`)

export default {
    getQuestions,
    selectQuestion,
    getRecommendBuilding
}
